import React from "react";

interface SparklingSvgProps {
    gradient?: boolean;
    brandBlend?: boolean;
}

const SparklingSvg: React.FC<
    Omit<React.ComponentPropsWithoutRef<"svg">, "viewBox" | "xmlns"> &
        SparklingSvgProps
> = ({ gradient = true, brandBlend = false, ...props }) => {
    const fillId = brandBlend
        ? "paint0_linear_sparkling_brandblend"
        : "paint0_linear_11547_158649";
    const strokeId = brandBlend
        ? "paint1_linear_sparkling_brandblend"
        : "paint1_linear_11547_158649";
    const stops = brandBlend ? (
        <>
            <stop stopColor="#7A30CA" />
            <stop offset="1" stopColor="#239C98" />
        </>
    ) : (
        <>
            <stop stopColor="#32D1B7" />
            <stop offset="0.695" stopColor="#349BC7" />
            <stop offset="1.0001" stopColor="#3664D6" />
        </>
    );

    return (
        <svg
            width="24"
            height="24"
            fill="none"
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path
                d="M5 3V7V3ZM3 5H7H3ZM6 17V21V17ZM4 19H8H4ZM13 3L15.286 9.857L21 12L15.286 14.143L13 21L10.714 14.143L5 12L10.714 9.857L13 3Z"
                fill={gradient ? `url(#${fillId})` : "currentColor"}
                stroke={gradient ? `url(#${strokeId})` : "currentColor"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {gradient && (
                <defs>
                    <linearGradient
                        id={fillId}
                        x1="3.5339"
                        y1="3.71163"
                        x2="22.1106"
                        y2="19.9167"
                        gradientUnits="userSpaceOnUse"
                    >
                        {stops}
                    </linearGradient>
                    <linearGradient
                        id={strokeId}
                        x1="3.5339"
                        y1="3.71163"
                        x2="22.1106"
                        y2="19.9167"
                        gradientUnits="userSpaceOnUse"
                    >
                        {stops}
                    </linearGradient>
                </defs>
            )}
        </svg>
    );
};

export default SparklingSvg;
